import { render, staticRenderFns } from "./LineofBusiness.vue?vue&type=template&id=36f33573"
import script from "./LineofBusiness.vue?vue&type=script&lang=js"
export * from "./LineofBusiness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports